import { PlanItem } from "../../plan.model";
import { Tooth } from "../../../../odontogram/odontogram.model";
import { ItemValidators } from "../../../item-validators";
import { AbstractTreatment } from "../treatment";
import { TreatmentPriceConfiguration } from "../../../../price/price.model";

export class ReRct extends AbstractTreatment {
  static validate(
    item: PlanItem,
    odontogram: Tooth[],
    items: PlanItem[],
  ): boolean {
    // validate teeth selected
    if (!ItemValidators.hasTeethSelected(item)) {
      return false;
    }

    // validate not missing
    if (!ItemValidators.notMissingTeeth(item, odontogram)) {
      return false;
    }

    // validate options
    if (!ItemValidators.hasChannelSelected(item)) {
      return false;
    }

    return true;
  }

  static apply(odontogram: Tooth[], item: PlanItem): Tooth[] {
    const resolvedConditions = [
      "rct",
      "apical-lesion",
      "root-resorption",
      "broken-instrument",
    ];

    odontogram
      .filter((tooth) => item.teeth.indexOf(tooth.number) > -1)
      .forEach((tooth) => {
        tooth.diagnosis = tooth.diagnosis.filter(
          (diagnosis) => !resolvedConditions.includes(diagnosis.condition),
        );
        tooth.plan.push({ treatment: item.treatment });
      });

    return odontogram;
  }

  static getPriceConfiguration(): TreatmentPriceConfiguration {
    return {
      type: "composite",
      identifier: this.getIdentifier(),
      single: false,
      variants: {
        identifier: "channels",
        type: "simple",
        options: [1, 2, 3, 4],
      },
    };
  }

  static getIdentifier(): string {
    return "re-rct";
  }

  static getItemResume(item: PlanItem): any {
    return [
      {
        name: "channels",
        value: item.options.channels
          ? ["plan.options.channels." + item.options.channels]
          : [],
      },
    ];
  }

  static getTableData(item: PlanItem): any {
    return [
      item.options.channels
        ? ["plan.options.channels." + item.options.channels]
        : [],
    ];
  }
}



// WEBPACK FOOTER //
// /app/src/app/core/store/plan-editor/plan/treatments/endodontics/re-rct.ts